<template>
	<div class="modal" tabindex="-1" role="dialog" id="speak-to-expert-modal">
		<div class="modal-dialog" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title tx-color-01">Speak to an Expert</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
					<div class="mt-2">
						<div v-if="requested" class="alert alert-success shadow-sm" role="alert">We have received your request and will contact you shortly.</div>

						<form class="row" @submit.prevent="speakToExpert">
							<div class="form-group col-md-12">
								<label class="form-label" for="fullname">Full Name <span class="text-danger">*</span></label>
								<input type="text" v-model="fullname" name="fullname" class="form-control" required />
							</div>
							<div class="form-group col-md-6">
								<label class="form-label" for="phone">Phone Number <span class="text-danger">*</span></label>
								<input type="tel" id="phone" v-model="phone" class="form-control" required />
							</div>
							<div class="form-group col-md-6">
								<label class="form-label" for="email">Email</label>
								<input type="email" v-model="email" name="email" class="form-control" />
							</div>
							<div class="col-12">
								<button type="submit" :disable="busy" class="btn btn-primary btn-block col-12">{{ busy ? 'Submitting': 'Submit'}}</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			fullname: null,
			email: null,
			phone: null,
			requested: false,
			busy: false,
		}
	},
	methods: {
		speakToExpert() {
			this.requested = false
			this.busy = true

			axios
				.post('/api/speak-to-expert', {
					fullname: this.fullname,
					email: this.email,
					phone: this.phone,
				})
				.then(() => (this.requested = true))
				.catch(() => (this.requested = true))
				.finally(() => (this.busy = false))
		},
	},
}
</script>
